import { consoleMsg, updateOfflineStatus, waitForContent, handleRefresh } from "../shared/utility";
import { devModePhotosValidation } from "../shared/app-data";
import { clearStorage } from "../shared/storage";

export class AppSettings extends HTMLElement {
	async connectedCallback() {
		await waitForContent("settings");
		this.innerHTML = app.content.settings;
		this.addEventListener("ionViewWillEnter", async () => {
			clearInterval(app.state.offlineSetIntervalId);

			app.state.offlineSetIntervalId = setInterval(updateOfflineStatus, app.state.offlineCheckInterval, "content-settings");
			await updateOfflineStatus("content-settings");
		});

		this.addEventListener("ionViewDidEnter", () => {
			app.state.currentPage = "settings";
			consoleMsg("App Settings entered");
			customElements.whenDefined("ion-refresher").then(() => {
				const refresher = this.querySelector("ion-refresher");
				refresher?.addEventListener("ionRefresh", handleRefresh);
			});

			const clearStorageAlert = document.getElementById("clearStorageAlert");

			clearStorageAlert.buttons = [
				{
					text: "OK",
					handler: () => {
						clearStorage();
						clearStorageAlert.dismiss();
					},
				},
			];

			/* IMPORTANT!!  Found an edge case bug today that hasn't been present in main application flow
         for five or six months.  When adding event listeners with anonymous functions, they can't be
         removed: the function name must exactly match, and because an anoymous function was used, there
         is no match and listeners stack up.  DON'T use this syntax for adding event listeners to my 
         UI components: unpredictable, buggy behavior will result:
         clearStorageButton.addEventListener("click", () => clearStorage());

         To avoid this, define small helper functions, like being used in the page initialization functions
         used in most other page classes (all those that collect user input for storage).
         */

			function handleClearStorageClick() {
				consoleMsg("Clear Storage button clicked");
				clearStorageAlert.present();
			}

			function handleUnregisterSwClick() {
				const unregister = navigator.serviceWorker.getRegistration().then((reg) => reg?.unregister());
				const clearCaches = caches.keys().then((names) => Promise.all(names.map((n) => caches.delete(n))));

				Promise.all([unregister, clearCaches]).then(() => {
					consoleMsg("SW unregistered and caches cleared");

					const alert = document.createElement("ion-alert");
					alert.header = "Service Worker Maintenance";
					alert.message = "Service worker successfully unregistered.";
					alert.buttons = [
						{
							text: "OK",
							handler: () => window.location.reload(),
						},
					];
					document.body.appendChild(alert);
					alert.present();
				});
			}

			const clearStorageButton = document.getElementById("clearStorageButton");
			const unregisterSwButton = document.getElementById("unregisterSwButton");

			if (clearStorageButton) {
				clearStorageButton.removeEventListener("click", handleClearStorageClick);
				clearStorageButton.addEventListener("click", handleClearStorageClick);
			} else {
				console.warn("Clear Storage button not found in DOM");
			}

			if (unregisterSwButton) {
				unregisterSwButton.removeEventListener("click", handleUnregisterSwClick);
				unregisterSwButton.addEventListener("click", handleUnregisterSwClick);
			} else {
				console.warn("Unregister Service Worker button not found in DOM");
			}

			const devModeToggle = document.getElementById("devModeToggle");
			//const checkPageRadios = document.getElementById("checkRadiosToggle");

			// Change state of devModeToggle based on current setting of isDevelopment flag
			if (devModeToggle) {
				devModeToggle.checked = app.settings.isDevelopment;
			}

			devModeToggle.addEventListener("ionChange", async (event) => {
				// Assign constant to track whether toggle is checked
				const mode = event.detail.checked;
				if (mode) {
					consoleMsg("DEV MODE ON");
					app.settings.checkRadios = true;
					app.settings.isDevelopment = true;
				} else {
					consoleMsg("DEV MODE OFF");
					app.settings.checkRadios = false;
					app.settings.isDevelopment = false;
				}

				// Explicitly set the checked property to reflect changes
				//devModeToggle.checked = app.settings.isDevelopment;
				// Toggle whether validation is performed on vehicle photos page based on current dev mode setting
				await devModePhotosValidation();
			});
		});
	}
}
